import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="booking-form"
export default class extends Controller {
  connect() {
    const dateField = document.getElementById('booking_date');
    const inputs = [...document.querySelectorAll('input:not([type=submit]):not([type=hidden]):not(.trix-input):not(.trix-button)')];
    const selects = [...document.querySelectorAll('select')];
    let formElements = inputs.concat(selects)
    const submit = document.querySelector('input.btn');

    inputs.forEach(el => {
      el.addEventListener('input', () => {
        submit.click();
      })
    });

    selects.forEach(el => {
      el.addEventListener('change', () => {
        submit.click();
      })
    });

    const attendees = document.querySelector('#booking_attendee_count');
    if(attendees.value == ''){
      attendees.value = 1;
    }
  }
}
